import { UserChatItem } from '@akin-home/chat';
import { Text } from '@akin-home/text/native';
import { colors } from '@akin-home/theme';
import styled from 'styled-components/native';

type Props = {
  item: UserChatItem;
};

export function UserTextItem(props: Props) {
  const { item } = props;

  return (
    <Row>
      <Container>
        <Text color="white">{item.text}</Text>
      </Container>
    </Row>
  );
}

const Row = styled.View`
  flex-direction: row;
  justify-content: flex-end;
`;

const Container = styled.View`
  background-color: ${colors.primary[70]};
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  border-bottom-left-radius: 20px;

  padding: 16px;
`;
